import { render, staticRenderFns } from "./pieMascotas.vue?vue&type=template&id=230f81b2"
import script from "./pieMascotas.vue?vue&type=script&lang=js"
export * from "./pieMascotas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports